import LanguageSpan from '../LanguageSpan';
import { ListElementProps } from './listElement.types';

const ListElement: (
  props: ListElementProps
) => JSX.Element = ({ id, items, selected, multiple, onChange, onFocus, onBlur, setOpen }) => {
  const cloneSelected = [...selected];
  const listMap = items.map((item, index) => {
    const indexOfSelected = cloneSelected.indexOf(item.key);
    const isSelected = indexOfSelected > -1;
    return (
      <li role="option" key={id + '_' + item.key}>
        <button
          id={`${id}_${index}`}
          onClick={e => {
            if (!multiple) {
              return onChange([item.key], e);
            }
            if (isSelected) {
              cloneSelected.splice(indexOfSelected, 1);
              return onChange(cloneSelected, e);
            }
            onChange([...selected, item.key], e);
          }}
          onFocus={onFocus}
          onBlur={onBlur}
          aria-selected={isSelected}
          onKeyDown={e => {
            if (e.key === 'Escape') setOpen?.(false);
            if (e.key === 'ArrowDown') {
              document.getElementById(`${id}_${index + 1}`)?.focus();
              e.preventDefault();
            }
            if (e.key === 'ArrowUp') {
              document.getElementById(`${id}_${index - 1}`)?.focus();
              e.preventDefault();
            }
            if (e.key === 'Tab') {
              setOpen?.(false);
            }
          }}
          className="option"
        >
          <em
            className="icon icon-haken"
            style={{ visibility: isSelected ? 'visible' : 'hidden' }}
          />
          <span className={'push-left'}>
            <LanguageSpan
              text={item.value}
              keyPrefix={id + '_' + item.key}
            ></LanguageSpan>
          </span>
        </button>
      </li>
    );
  });
  return <>{listMap}</>;
};

export default ListElement;
